import Link from 'next/link';
import { ANON_DAILY_CALL_LIMIT, ROUTES } from '#/data/constants';

interface AnonUsageBadgeProps {
  remaining: number | null | undefined;
}

/**
 * 비로그인 사용자의 남은 호출 횟수를 표시하고 회원가입을 유도하는 배지 컴포넌트
 */
export default function AnonUsageBadge({ remaining }: AnonUsageBadgeProps) {
  if (remaining === null || remaining === undefined) return null;

  const exhausted = remaining === 0;

  if (exhausted) {
    return (
      <span className="inline-flex items-center gap-1.5 text-sm">
        <span className="text-red-500 font-semibold">
          오늘 무료 체험 횟수를 모두 사용했습니다.
        </span>
        <Link
          href={ROUTES.REGISTER}
          className="text-primary font-semibold underline underline-offset-2 hover:text-primary/80 transition-colors"
        >
          회원가입
        </Link>
        <span className="text-muted-foreground">
          하면 더 많이 사용할 수 있어요!
        </span>
      </span>
    );
  }

  return (
    <span className="inline-flex items-center gap-1.5 text-sm text-muted-foreground">
      오늘 남은 횟수: <strong className="text-primary">{remaining}</strong>/
      {ANON_DAILY_CALL_LIMIT}
      <span className="text-xs">
        ·{' '}
        <Link
          href={ROUTES.REGISTER}
          className="text-primary underline underline-offset-2 hover:text-primary/80 transition-colors"
        >
          회원가입
        </Link>
        시 추가 사용가능
      </span>
    </span>
  );
}
